import React from "react";
import ReactDOM from "react-dom/client";
import './sentry';
//
import "rc-slider/assets/index.css";
import "./fonts/line-awesome-1.3.0/css/line-awesome.css";
import "./index.css";
import "./styles/index.scss";

//
import PageError from "containers/PageError";
import { CartProvider } from "context/cart/cart.context";
import { ErrorBoundary } from 'react-error-boundary';
import { Provider } from "react-redux";
import App from "./App";
import { store } from "./store";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <CartProvider>
        <ErrorBoundary FallbackComponent={PageError}>
          <App />
        </ErrorBoundary>
      </CartProvider>
    </Provider>
  </React.StrictMode>
);
